import React from "react";
import "../animations.css";

interface Props {
  size?: number;
}
 
const LoadingSpinner: React.FC<Props> = ({ size = 40 }) => (
  <div className="flex items-center justify-center w-full py-10">
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      className="animate-spin-svg"
    >
      <circle
        cx="20"
        cy="20"
        r="16"
        fill="none"
        stroke="rgb(var(--color-gold-2))"
        strokeWidth="3"
        strokeDasharray="60 40"
        strokeLinecap="round"
      />
    </svg>
  </div>
);
 
export default LoadingSpinner;